import { getTargetOrigin } from './redirectRouteToDomain';

const targetOriginSuffixes = {
  'bg-BG': 'bg.fashionunited.com',
  'cs-CZ': 'fashionunited.cz',
  'da-DK': 'fashionunited.dk',
  'de-AT': 'fashionunited.at',
  'de-CH': 'fashionunited.ch',
  'de-DE': 'fashionunited.de',
  'el-CY': 'cy.fashionunited.com',
  'el-GR': 'gr.fashionunited.com',
  'en-AU': 'au.fashionunited.com',
  'en-CA': 'fashionunited.ca',
  'en-GB': 'fashionunited.uk',
  'en-IE': 'fashionunited.ie',
  'en-IN': 'fashionunited.in',
  'en-NZ': 'fashionunited.nz',
  'en-US': 'fashionunited.com',
  'es-AR': 'fashionunited.com.ar',
  'es-CL': 'fashionunited.cl',
  'es-CO': 'fashionunited.co',
  'es-ES': 'fashionunited.es',
  'es-MX': 'fashionunited.mx',
  'es-PE': 'fashionunited.com.pe',
  'et-EE': 'ee.fashionunited.com',
  'fi-FI': 'fashionunited.fi',
  'fr-BE': 'fashionunited.be',
  'fr-CA': 'fashionunited.ca',
  'fr-CH': 'fashionunited.ch',
  'fr-FR': 'fashionunited.fr',
  'fr-LU': 'fashionunited.lu',
  'hr-HR': 'hr.fashionunited.com',
  'hu-HU': 'fashionunited.hu',
  'it-CH': 'fashionunited.ch',
  'it-IT': 'fashionunited.it',
  'ja-JP': 'fashionunited.jp',
  'lt-LT': 'lt.fashionunited.com',
  'lv-LV': 'lv.fashionunited.com',
  'mt-MT': 'mt.fashionunited.com',
  'nb-NO': 'fashionunited.no',
  'nl-BE': 'fashionunited.be',
  'nl-NL': 'fashionunited.nl',
  'pl-PL': 'fashionunited.pl',
  'pt-BR': 'fashionunited.com.br',
  'pt-PT': 'fashionunited.pt',
  'ro-RO': 'ro.fashionunited.com',
  'ru-RU': 'ru.fashionunited.com',
  'sk-SK': 'sk.fashionunited.com',
  'sl-SI': 'si.fashionunited.com',
  'sv-SE': 'fashionunited.se',
  'tr-TR': 'fashionunited.com.tr',
  'zh-CN': 'cn.fashionunited.com',
  'zh-HK': 'fashionunited.hk',
};

const getOriginByLocale = (sourceOrigin, locale) => getTargetOrigin(
  sourceOrigin,
  targetOriginSuffixes[locale],
);

export default getOriginByLocale;
